





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import Branches from '@/components/Branches/Branches.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'AgencyBranchSettings',
  	components: { Branches, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getBranches();
		AgencySettingsModule.getBusinessHours();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingBranches;
  	}
}
